import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=5962c7c0&scoped=true"
import script from "./DataFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=5962c7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962c7c0",
  null
  
)

export default component.exports